import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "@components/Layout";
import PageLoader from "@components/Loader/Loader";
import Login from "@pages/Login";
import Dashboard from "@pages/Dashboard";
import SaasPrs from "@pages/SaasPrs";
import NotFound from "@pages/NotFound";

const RoutesComponent = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* All routes use the app Layout */}
        <Route path="*" element={
          <Layout>
            <Routes>
              {/* Public Route */}
              <Route path="/login" element={<Login />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/saas-prs"
                element={
                  <ProtectedRoute>
                    <SaasPrs />
                  </ProtectedRoute>
                }
              />

              {/* 404 Not Found */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
